export default __webpack_public_path__ + "static/media/icon_upload.71cf1206.svg";